import { DOCUMENT } from "@angular/common";

/**
 * Mapping for translation keys, so we don't have to use long text in source code. Please keep in mind, that the
 * german default translations are the keys, so don't change them, if you wan't to change the text.
 * Instead change the de_DE translations!
 */
export const KEYS = {
  EDITOR: {
    FORMULA_FN_ROUND: 'Runden',
    FORMULA_FN_CEIL: 'Aufrunden',
    FORMULA_FN_FLOOR: 'Abrunden',
    FORMULA_FN_TRUNC: 'Nachkommastellen entfernen',
    FORMULA_FN_ABS: 'Absolutwert',
    FORMULA_FN_MIN: 'Kleinster Wert',
    FORMULA_FN_MAX: 'Größter Wert',
    FORMULA_FN_POW: 'Potenz',
    FORMULA_FN_SQRT: 'Quadratwurzel',
    FORMULA_FN_CBRT: 'Kubikwurzel',
    FORMULA_FN_HYPOT: 'Wurzel der Quadratsumme',
    FORMULA_FN_SIGN: 'Vorzeichen',
    FORMULA_FN_RANDOM: 'Zufallszahl',

    FORMULA_RUNTIME_CALL: 'Dieser Funktionsaufruf wird von der Ausfüll-App nicht unterstützt',
    FORMULA_MODE: 'Bearbeitungsmodus',
    FORMULA_ASSISTED: 'Unterstützt',
    FORMULA_SOURCE: 'Quellcode',
    FORMULA_INSERT: 'Formelbaustein einfügen',
    FORMULA_FUNCTION: 'Funktion',
    FORMULA_IF_THEN: 'Wenn / Dann / Sonst',
    FORMULA_BLOCKS: 'Bausteine',
    FORMULA_MATCH: 'Textmuster prüfen',
    FORMULA_EDIT_PART: 'Baustein bearbeiten',
    FORMULA_GROUP: 'Klammern setzen',
    FORMULA_NOT: 'Verneinen',
    FORMULA_NUMBER: 'In Zahl umwandeln',
    FORMULA_FALLBACK: 'Ersatzwert bei fehlender Antwort',
    FORMULA_TRUE: 'Wahr',
    FORMULA_FALSE: 'Falsch',
    FORMULA_TEXT: 'Text',
    FORMULA_PATTERN: 'Regulärer Ausdruck',
    FORMULA_STATEMENT: 'Wenn-Anweisung',
    FORMULA_WHEN: 'Wenn',
    FORMULA_THEN: 'Dann',
    FORMULA_ELSE: 'Sonst',
    FORMULA_ARGUMENT: 'Wert',
    FORMULA_REMOVE_ARGUMENT: 'Wert entfernen',
    FORMULA_NO_ARGUMENTS: 'Diese Funktion benötigt keine Werte.',
    FORMULA_COMPLETE_FIELDS: 'Bitte füllen Sie alle Werte aus.',
    FORMULA_APPLY: 'Übernehmen',
    FORMULA_BRANCH_HINT: 'Bedingung und Ergebnisse können weitere Formeln enthalten.',
    FORMULA_ASSISTED_HINT: 'Direkt tippen oder Bausteine einfügen. Markierten Code können Sie mit einer Funktion umschließen. Bausteine sind anklickbar.',
    FORMULA_SOURCE_HINT: 'Unveränderter JavaScript-Quelltext. Der letzte Ausdruck liefert das Ergebnis, ohne return.',
    FORMULA_SOURCE_ONLY: 'Diese Formel lässt sich nicht zuverlässig unterstützt bearbeiten. Sie bleibt unverändert und kann im Quellcode bearbeitet werden.',
    FORMULA_DUPLICATE_NAME: 'Es gibt bereits eine Formel mit diesem Namen.',
    FORMULA_RUNTIME_HINT: 'Die Formel verwendet die Werte beim Ausfüllen. Andere Formeln lassen sich ebenfalls verwenden, der Editor setzt sie beim Speichern ein.',

    DEPENDENCY_ALL_SOURCES: 'Alle',
    DEPENDENCY_ANSWER: 'Antwort',
    DEPENDENCY_EDIT: 'Abhängigkeiten bearbeiten',
    DEPENDENCY_HINT: 'Legen Sie fest, wann diese Frage angezeigt wird.',
    DEPENDENCY_SHOW: 'FRAGE ANZEIGEN',
    DEPENDENCY_MORE: 'Weitere Optionen',
    DEPENDENCY_WHEN: 'Diese Frage anzeigen, wenn',
    DEPENDENCY_ALWAYS: 'Diese Frage wird immer angezeigt.',
    DEPENDENCY_UNSUPPORTED: 'Dieser Ausdruck kann nicht verlustfrei im visuellen Editor bearbeitet werden.',
    DEPENDENCY_PRESERVED: 'Er bleibt unverändert. Sie können die Bedingungen entfernen und neu aufbauen.',
    DEPENDENCY_SOURCE: 'Technischen Ausdruck anzeigen',
    DEPENDENCY_APPLY_HINT: 'Änderungen werden erst mit Übernehmen wirksam.',
    DEPENDENCY_REMOVE: 'Abhängigkeiten entfernen',
    DEPENDENCY_REMOVE_CONDITIONS: 'Bedingungen entfernen',
    DEPENDENCY_ALL: 'Alle Bedingungen müssen zutreffen',
    DEPENDENCY_ANY: 'Mindestens eine Bedingung muss zutreffen',
    DEPENDENCY_CHOOSE: 'Frage oder Variable wählen',
    DEPENDENCY_SEARCH: 'Suchen Sie nach einer Frage, Antwort oder Variable.',
    DEPENDENCY_RUNTIME: 'Die Bedingung verwendet den Wert beim Ausfüllen.',
    DEPENDENCY_ANSWERS: 'Fragen und Antworten',
    DEPENDENCY_SELECTED: 'ist ausgewählt',
    DEPENDENCY_NOT_SELECTED: 'ist nicht ausgewählt',
    DEPENDENCY_FALSE: 'ist ausdrücklich abgewählt',
    DEPENDENCY_NOT_FALSE: 'ist nicht ausdrücklich abgewählt',
    DEPENDENCY_VALUE: 'Wert wählen',
    DEPENDENCY_REGEX_HINT: 'Regulärer Ausdruck, zum Beispiel ^ABC.',
    DEPENDENCY_REGEX: 'entspricht dem Muster',
    DEPENDENCY_EMPTY_GROUP: 'Bitte ergänzen oder entfernen Sie die leere Gruppe.',
    DEPENDENCY_ADD: 'Bedingung hinzufügen',
    DEPENDENCY_ADD_GROUP: 'Untergruppe hinzufügen',
    DEPENDENCY_VISIBILITY: 'Sichtbarkeit',
    DEPENDENCY_EDIT_RULES: 'Bedingungen bearbeiten',
    DEPENDENCY_CHOOSE_REQUIRED: 'Bitte wählen Sie eine Frage oder Variable.',
    DEPENDENCY_MISSING: 'Diese Antwort oder Variable existiert nicht mehr. Bitte ersetzen Sie sie.',
    DEPENDENCY_PATH_INVALID: 'Dieser Variablenname wird in Bedingungen nicht unterstützt.',
    DEPENDENCY_OPERATOR_INVALID: 'Dieser Vergleich wird nicht unterstützt.',
    DEPENDENCY_VALUE_INVALID: 'Bitte geben Sie einen gültigen Vergleichswert ein.',
    DEPENDENCY_REGEX_INVALID: 'Bitte geben Sie ein gültiges Muster ohne Schrägstriche ein.',
    DEPENDENCY_TEXT_INVALID: 'Die vorhandene Auswertung unterstützt diesen Vergleichstext nicht.',
    DEPENDENCY_EXISTING: 'Vorhandener Ausdruck',
    DEPENDENCY_CONFLICT: 'Die Bedingungen wurden zwischenzeitlich geändert. Bitte öffnen Sie den Editor erneut.',
    DEPENDENCY_MALE: 'Männlich',
    DEPENDENCY_FEMALE: 'Weiblich',
    DEPENDENCY_DIVERSE: 'Divers',
    DEPENDENCY_CASE: 'Fallnummer',
    DEPENDENCY_PATIENT_NR: 'Patientennummer',
    DEPENDENCY_ZIP: 'Postleitzahl',
    DEPENDENCY_CITY: 'Ort',
    DEPENDENCY_STREET: 'Straße',
    DEPENDENCY_STREET_NR: 'Hausnummer',
    DEPENDENCY_LOCATION: 'Standort',
    DEPENDENCY_DATE_INVALID: 'Bitte geben Sie ein gültiges Datum ein.',

    CONDITION_TEXT_CHARACTERS: 'Vergleichstext darf keine HTML-Zeichen, Backslashes, geschweiften Klammern oder Zeilenumbrüche enthalten.',
    CONDITION_INSERT: 'Bedingung einfügen',
    CONDITION_EDIT: 'Bedingung bearbeiten',
    CONDITION_HINT: 'Legen Sie fest, wann ein Text angezeigt wird.',
    CONDITION_IF: 'WENN',
    CONDITION_UNLESS: 'WENN NICHT',
    CONDITION_THEN: 'DANN',
    CONDITION_ELSE: 'SONST',
    CONDITION_END: 'ENDE',
    CONDITION_AND: 'UND',
    CONDITION_OR: 'ODER',
    CONDITION_INVERT: 'Bedingung umkehren',
    CONDITION_ADD_RULE: 'Weitere Regel',
    CONDITION_EDIT_TEXT: 'Text direkt im Editor bearbeiten',
    CONDITION_ADD_ELSE: 'SONST-Bereich hinzufügen',
    CONDITION_EDIT_ELSE: 'Alternativen Text direkt im Editor bearbeiten',
    CONDITION_SOURCE: 'Handlebars anzeigen',
    CONDITION_INVALID: 'Bitte wählen Sie alle Variablen und geben Sie gültige Vergleichswerte ein.',
    CONDITION_UNWRAP_HINT: 'Beim Entfernen der Bedingung bleiben die Texte aus DANN und SONST erhalten.',
    CONDITION_UNWRAP: 'Bedingung entfernen',
    CONDITION_APPLY: 'Übernehmen',
    CONDITION_ADD: 'Einfügen',
    CONDITION_CONNECT: 'Regeln verknüpfen',
    CONDITION_ALL: 'Alle Regeln treffen zu (UND)',
    CONDITION_ANY: 'Mindestens eine Regel trifft zu (ODER)',
    CONDITION_REMOVE_GROUP: 'Gruppe entfernen',
    CONDITION_RULE: 'Regel',
    CONDITION_GROUP: 'Gruppe',
    CONDITION_COMPARE: 'Vergleich',
    CONDITION_REMOVE_RULE: 'Regel entfernen',
    CONDITION_TYPE: 'Werttyp',
    CONDITION_VALUE: 'Vergleichswert',
    CONDITION_YES: 'Ja',
    CONDITION_NO: 'Nein',
    CONDITION_CHOOSE: 'Variable wählen',
    CONDITION_TEXT: 'Text',
    CONDITION_NUMBER: 'Zahl',
    CONDITION_BOOLEAN: 'Ja / Nein',
    CONDITION_DATE: 'Datum',
    CONDITION_VARIABLE: 'Variable',
    CONDITION_TRUTHY: 'ist wahr',
    CONDITION_PRESENT: 'ist ausgefüllt',
    CONDITION_EMPTY: 'ist nicht ausgefüllt',
    CONDITION_EQ: 'ist gleich',
    CONDITION_NE: 'ist ungleich',
    CONDITION_GT: 'ist größer als',
    CONDITION_GTE: 'ist mindestens',
    CONDITION_LT: 'ist kleiner als',
    CONDITION_LTE: 'ist höchstens',

    TEXT_VARIABLE_CANCEL: 'Abbrechen',
    INSERT_TEXT_VARIABLE: 'Variable einfügen',
    TEXT_VARIABLE_HINT: 'Wählen Sie einen Wert aus. Er wird an der Cursorposition eingefügt.',
    CHANGE_TEXT_VARIABLE: 'Variable ändern',
    CHANGE_TEXT_VARIABLE_HINT: 'Die aktuelle Variable ist markiert. Wählen Sie einen anderen Wert, um sie zu ersetzen.',
    TEXT_VARIABLE_SEARCH: 'Name oder Variable suchen…',
    TEXT_VARIABLE_CATEGORIES: 'Variablenkategorien',
    TEXT_VARIABLE_ALL: 'Alle Variablen',
    TEXT_VARIABLE_PATIENT: 'Patientendaten',
    TEXT_VARIABLE_CUSTOM: 'Patienten-Zusatzfelder',
    TEXT_VARIABLE_ANSWERS: 'Fragebogenvariablen',
    TEXT_VARIABLE_SCORES: 'Scores',
    TEXT_VARIABLE_FORMULAS: 'Formelergebnisse',
    TEXT_VARIABLE_EXTERNAL: 'Externe Werte',
    TEXT_VARIABLE_GENERAL: 'Datum und Uhrzeit',
    TEXT_VARIABLE_EMPTY: 'Keine passende Variable gefunden',
    TEXT_VARIABLE_EMPTY_HINT: 'Ändern Sie den Suchbegriff oder wählen Sie eine andere Kategorie.',
    TEXT_VARIABLE_VALUE_HINT: 'Der tatsächliche Wert wird beim Ausfüllen eingesetzt. Fehlende Werte bleiben leer.',
    TEXT_VARIABLE_FIRST_NAME: 'Vorname',
    TEXT_VARIABLE_LAST_NAME: 'Nachname',
    TEXT_VARIABLE_FULL_NAME: 'Vollständiger Name',
    TEXT_VARIABLE_SALUTATION: 'Anrede',
    TEXT_VARIABLE_BIRTH_DATE: 'Geburtsdatum',
    TEXT_VARIABLE_AGE: 'Alter in Jahren',
    TEXT_VARIABLE_AGE_MONTHS: 'Alter in Monaten',
    TEXT_VARIABLE_ANONYMOUS: 'Anonymer Patient',
    TEXT_VARIABLE_PSEUDONYMOUS: 'Pseudonymer Patient',
    TEXT_VARIABLE_DATE: 'Aktuelles Datum',
    TEXT_VARIABLE_TIME: 'Aktuelle Uhrzeit',

    PROPERTY_SECTION: 'Bereich',
    DRAG_ELEMENT: 'Ziehen zum Verschieben',
    ELEMENT_ACTIONS: 'Elementaktionen',
    POSITION: 'Position',
    INSERT_ELEMENT_HERE: 'Element hier einfügen',
    SHOW_MORE: 'Mehr anzeigen',
    SHOW_LESS: 'Weniger anzeigen',
    MORE_SETTINGS: 'Weitere Einstellungen',
    SETTINGS_ACTIVE: 'gesetzt',
    TITLE: 'Titel',
    MOVE_UP: 'Nach oben',
    MOVE_DOWN: 'Nach unten',
    REMOVE_AUDIO: 'Audio entfernen',
    PROPERTIES: 'Eigenschaften',
    RESIZE_PROPERTIES: 'Breite des Eigenschaftenbereichs ändern',
    RESIZE_PROPERTIES_HINT: 'Ziehen zum Anpassen, Doppelklick zum Zurücksetzen',
    SELECT_QUESTION_HINT: 'Wählen Sie eine Frage aus, um ihre Eigenschaften zu bearbeiten.',
    LEFT_TEXT: 'Text links',
    RIGHT_TEXT: 'Text rechts',
    CONFIG_ERROR: 'Konfigurationsfehler',
    QUESTIONNAIRE_API_URL_UNSET: 'API URL zum Abrufen von Fragebogen-Vorlagen wurde nicht gefunden. Bitte konfigurieren:',
    RESUME_HINT: 'Ungespeicherte Änderungen aus einer früheren Sitzung',
    RESUME_APPLY: 'Übernehmen',
    RESUME_DISCARD: 'Verwerfen',
    QUESTIONNAIRE_EDITOR: 'Editor',
    ENTER_TITLE: 'Titel eingeben...',
    ENTER_SUBJECT: 'Betreff eingeben...',
    QUESTIONNAIRE_TYPE: 'Typ',
    QUESTIONNAIRE: 'Fragebogen',
    INFORMATION_SHEET: 'Aufklärungsbogen',
    STATUS: 'Status',
    DRAFT: 'Entwurf',
    APPROVED: 'Freigegeben',
    REV: 'Rev.',
    FILTER_GROUPS: 'Fachgruppen',
    SAVE: 'Speichern',
    SHOW: 'Zeige',
    NO_CONTENT: 'Keine Inhalte',
    ALL_CONTENT: 'Alle Inhalte',
    ALL_IMAGES: 'Alle Bilder',
    ALL_VIDEOS: 'Alle Videos',
    ALL_AUDIO: 'Alle Audio',
    ALL_DESCRIPTIONS: 'Alle Beschreibungen',
    ALL_DEPENDENCIES: 'Alle Abhängigkeiten',
    ALL_VARIABLES: 'Alle Variablen',
    EXPAND_ELEMENTS: 'Elemente ausklappen',
    FOLD_ELEMENTS: 'Elemente einklappen',
    JUMP_TO_ELEMENT: 'Zu Element springen',
    ELEMENTS: 'Elemente',
    FULL_SCREEN: 'Vollbild',
    OPTIONS: 'Optionen',
    DESCRIPTION: 'Beschreibung',
    MAIL_TEXT: 'Mailtext',
    ENTER_MAIL_TEXT: 'Mailtext eingeben...',
    IMAGE: 'Bild',
    ADD_IMAGE: 'Bild einfügen',
    SCORING: 'Scoring',
    PDF_FORMS: 'PDF Vorlagen',
    PDF_FORMS_INTRO: 'Ausfüllbare PDF-Vorlagen verknüpfen',
    PDF_FORMS_HELP: 'Ausgewählte PDF-Formulare werden mit Antworten und Variablen aus dem Fragebogen befüllt. Welcher Wert in welches Formularfeld kommt, legen Sie im Bereich PDF Mapping oder direkt bei der jeweiligen Frage fest.',
    PDF_FORMS_OPEN_MAPPING: 'Zum PDF Mapping',
    EXTERN_VARIABLES: 'Externe Variablen',
    FORMULA_VARIABLES: 'Formeln',
    EXCEL: 'Export',
    FORMULA: 'Formel',
    PDF: 'PDF',
    GDT: 'GDT',
    FILL_OPTIONS: 'Ausfüllen',
    GENERATE_INTERNAL_PDF: 'Internes PDF erstellen',
    SKIP_UNSIGNED_PDF: 'Export nicht signierter Dokumente überspringen',
    PDF_PLAIN_CARDS: 'Fragen-Karten randlos darstellen (ohne Rahmen und Schatten)',
    PDF_FONT_SCALE: 'Schriftgröße',
    PDF_FONT_SCALE_DEFAULT: 'Standard',
    PDF_COMPACT_SPACING: 'Kompakte Abstände zwischen den Fragen',
    PDF_INLINE_CHOICES: 'Antworten im PDF in einer Zeile darstellen',
    FORCE_MANDATORY: "Beantwortung von Pflichtfragen erzwingen",
    SKIP_LIST: "Fragebogen Liste überspringen bei einzelnem Fragebogen",
    SKIP_SUBMIT_CONFIRMATION: "Bestätigungsdialog beim Abgeben des Fragebogens überspringen",
    ADD_QUESTIONNAIRE_TITLE_TO_GDT: "Fragebogen Titel in GDT Datei einfügen",
    ADD_SCORING_TO_GDT: 'Scoring Ergebnisse in GDT Datei einfügen',
    ADD_FORMULA_RESULTS_TO_GDT: 'Formel Ergebnisse in GDT Datei einfügen',
    SCORING_VARIABLE: 'Scoring Variable',
    ADD_SCORING_VARIABLE: 'Scoring Variable einfügen',
    ADD_EXTERN_VARIABLE: 'Externe Variable einfügen',
    ADD_FORMULA_VARIABLE: 'Formel Variable einfügen',
    SCORING_VALUE_FOR_THIS_ANSWER: 'Wert',
    ENTER_DESCRIPTION: 'Beschreibung eingeben...',
    ERROR_LOADING_QUESTIONNAIRE: 'Beim Laden des Fragebogens ist ein Fehler aufgetreten',
    SUCCESSFULLY_SAVED_QUESTIONNAIRE: 'Der Fragebogen wurde erfolgreich gespeichert',
    ERROR_SAVING_QUESTIONNAIRE: 'Beim Speichern des Fragebogens ist ein Fehler aufgetreten',
    PLEASE_INSERT_TITLE_TO_SAVE: 'Achtung: Bitte Fragebogen Titel eingeben, um zu speichern',
    PLEASE_INSERT_FILTER_GROUP_TO_SAVE: 'Achtung: Bitte Fachgruppe zuordnen, um zu speichern',
    QUESTION_DELETE_ELEMENT: 'Sind sie sicher, dass sie dieses Element entfernen möchten?',
    QUESTIONNAIRE_LIMIT_REACHED: 'Lizenz Limit erreicht. Es können keine weiteren Fragebögen angelegt werden.',
    QUESTIONNAIRE_NO_PERMISSION: 'Sie haben keine Berechtigung, diesen Fragebogen zu bearbeiten.',
    DYNAMIC: 'Dynamisch',
    STATIC: 'Statisch',
    DIAGRAMS: 'Diagramme',
    COPY_QUESTION: 'Frage kopieren',
    INFO_TEXT: 'Infotext',
    PAGE_BREAK: 'Seitenumbruch',
    INPUT: 'Eingabe',
    NUMBER: 'Zahl',
    DATE: 'Datum',
    FREE_TEXT: 'Freitext',
    TEXT_MULTILINE: 'Freitext Mehrzeilig',
    MULTI_VALUE: 'Multiwerte',
    CHOICE: 'Auswahl',
    SINGLE_CHOICE: 'Eine Antwort',
    MULTIPLE_CHOICE: 'Mehrere Antworten',
    QUESTION_MATRIX: 'Fragen-Matrix',
    MEDIA: 'Medien',
    TAKE_PICTURE: 'Bild aufnehmen / hochladen',
    DRAWING: 'Zeichnung',
    SIGNATURE: 'Unterschrift',
    TEMPLATES: 'Vorlagen',
    YES_NO: 'Ja/Nein',
    YES_NO_MISC: 'Ja/Nein/Sonstiges',
    MULTIPLE_CHOICE_MISC: 'Mehrere Antworten/Sonstiges',
    ADD_ELEMENT: 'Element hinzufügen',
    ERROR_READING_QUESTIONNAIRE_JSON: 'Fragebogen JSON konnte nicht gelesen werden. Fehler:',
    QUESTIONNAIRE_JSON: 'Fragebogen JSON',
    IMPORT: 'Import',
    EXPORT: 'Export',
    DEBUGGING: 'Debugging',
    UNPACKED_EXPORT: 'Unpacked Export',
    QUESTIONNAIRE_PREVIEW: 'Fragebogen Vorschau',
    QUESTION: 'Frage',
    VARIABLE: 'Variable',
    AND: 'UND',
    OR: 'ODER',
    GROUP: 'Gruppe',
    CONDITION: 'Bedingung',
    SHOW_THIS_QUESTION_IF: 'Diese Frage einblenden wenn:',
    ADD_CONDITION: 'Bedingung hinzufügen',
    BACKGROUND_COLOR: 'Hintergrundfarbe',
    PEN_COLOR: 'Stiftfarbe',
    HEIGHT: 'Höhe',
    BACKGROUND_IMAGE: 'Hintergrundbild',
    AUTO_UNLOCK: 'Automatisch entsperren',
    ERROR_TRANSFERRING_IMAGE: 'Beim Übertragen des Bildes ist ein Fehler aufgetreten!',
    EDIT: 'Bearbeiten',
    REMOVE: 'Entfernen',
    ADD_ANSWER: 'Antwort hinzufügen',
    ADD_ENTRY: 'Eintrag hinzufügen',
    DATE_YMD_HM_TEXT: 'Monat, Jahr und Tag + Zeit : DD.MM.YYYY HH:mm',
    DATE_YMD_TEXT: 'Monat, Jahr und Tag: DD.MM.YYYY',
    DATE_YM_TEXT: 'Monat und Jahr: MM.YYYY',
    DATE_Y_TEXT: 'Jahr: YYYY',
    ROWS: 'Zeilen',
    ROW: 'Zeile',
    COLUMNS: 'Spalten',
    COLUMN: 'Spalte',
    VARIABLES: 'Variablen',
    ALLOW_HTML: 'Formatierten Text bei Copy & Paste erlauben',
    INPUT_OPTIONS: 'Eingabeoptionen',
    VALIDATION: 'Validierung',
    ADD_ROW: 'Zeile hinzufügen',
    ADD_COLUMN: 'Spalte hinzufügen',
    ANSWERS_PER_ROW: 'Antworten pro Zeile',
    PREVIEW: 'Vorschau',
    CONFIGURE_CELLS: 'Zellen konfigurieren',
    SELECT_MATRIX_CELL: 'Zelle auswählen, um Variablen und Scoring festzulegen.',
    MATRIX_NO_SCORING: 'Legen Sie zuerst eine Scoring-Variable im Bereich Scoring des Fragebogens an.',
    PLEASE_SELECT: 'Bitte wählen...',
    MIN: 'Min',
    MAX: 'Max',
    STEPS: 'Schritte',
    SCALE: 'Skala',
    SCALE_START_LABEL: 'Start-Label',
    SCALE_END_LABEL: 'End-Label',
    UNIT: 'Einheit',
    UNIT_EXAMPLE: 'Bsp. Kg',
    DISPLAY_TYPE: 'Anzeigetyp',
    INPUT_FIELD: 'Eingabefeld',
    SLIDER: 'Slider',
    NUMBER_WHEEL: 'Zahlen-Auswahlrad',
    TYPE_OF_SIGNATURE: 'Art der Unterschrift',
    QUESTION_TYPE_HAS_NO_CONFIGURABLE_CONTENT: 'Dieser Fragetyp hat keinen konfigurierbaren Inhalt',
    CLOSE: 'Schließen',
    SCOPE: 'Gültigkeitsbereich',
    VARIABLE_NAME: 'Name der Variable',
    RETURN_VALUE: 'Rückgabewert',
    SAVE_VARIABLE: 'Variable speichern',
    RESET_VARIABLE: 'Variable zurücksetzen',
    DELETE_VARIABLE: 'Variable löschen',
    NO_VARIABLES_CONFIGURED: 'Es wurden keine Variablen konfiguriert.',
    INVALID_VAR_NAME_TEXT: 'Variablenname ungültig. Mind. 3 Zeichen. Nur [a-zA-Z0-9_] erlaubt. Darf nicht mit Zahl beginnen.',
    VAR_NAME_INVALID_CHARS: 'Nicht erlaubt: %s. Möglich sind Buchstaben ohne Umlaute, Ziffern und _.',
    VAR_NAME_SPACE: 'Leerzeichen',
    VAR_NAME_DIGIT_START: 'Der Name darf nicht mit einer Ziffer beginnen.',
    VAR_NAME_TOO_SHORT: 'Zu kurz, bitte mindestens %s Zeichen.',
    VAR_NAME_TOO_LONG: 'Zu lang, höchstens %s Zeichen.',
    INVALID_NUMBER_TEXT: 'Eingabe ungültig. Nur Zahlen erlaubt.',
    DUPLICATE_VAR_NAME_TEXT: 'Variablenname wird bereits bei einer anderen Frage verwendet.',
    INVALID_EXPRESSION: 'Eingabe ungültig. Nur Variablen, Zahlen, Arithmetische Operatoren und Math Funktionen erlaubt.',
    INVALID_CIRCULAR_EXPRESSION: 'Formeln verwenden sich gegenseitig',
    FORMULA_NOT_INLINABLE: 'Diese Formel lässt sich nicht in anderen Formeln verwenden (Schleife oder mehrfach zugewiesene Hilfsvariable)',
    FORMULA_BROKEN_DEPENDENCY: 'Die verwendete Formel ist fehlerhaft',
    FORMULA_USED_BY: 'genutzt von',
    FORMULA_TOKEN_FORMULA: 'Formel',
    TEXT_VARIABLE_CURRENT: 'Aktuell',
    FORMULA_SYNTAX_ERROR: 'Syntaxfehler in der Formel',
    FORMULA_UNKNOWN_VARIABLE: 'Variable existiert nicht',
    FORMULA_UNKNOWN_MATH_FUNCTION: 'Unbekannte Math Funktion',
    FORMULA_MISSING_CLOSING_PAREN: 'schließende Klammer fehlt',
    FORMULA_EXTRA_CLOSING_PAREN: 'schließende Klammer zu viel',
    FORMULA_AUTOFIX: 'Formel automatisch reparieren',
    FORMULA_AUTOFIX_DONE: 'Formel automatisch repariert',
    FORMULA_BROKEN_TOAST: 'Dieser Fragebogen enthält fehlerhafte Formeln',
    ACTIVE: 'Aktiv',
    MANDATORY: 'Pflicht',
    MARK: 'Markieren',
    HIDE_IN_PDF: 'In PDF nicht anzeigen',
    HIDE_IN_APP: 'Beim Ausfüllen nicht anzeigen',
    HIDE_IN_XLS: 'In Tabellen Export nicht anzeigen',
    UPLOAD: 'Upload',
    ALLOW_UPLOAD: 'Upload erlauben',
    UPLOAD_PREFIX_HELP: 'Upload ist eingerichtet. Dieser Name wird als Dateinamen-Präfix verwendet. Mehrere Dateien erhalten zusätzliche Namensbestandteile. Sie können den Namen hier ändern.',
    IMAGES: 'Bilder',
    VIDEOS: 'Videos',
    AUDIO: 'Audio',
    ADD_IMAGES: 'Bilder hinzufügen',
    ADD_VIDEOS: 'Videos hinzufügen',
    ADD_AUDIO: 'Audio hinzufügen',
    DEPENDENCIES: 'Abhängigkeiten',
    MODE: 'Modus',
    MODE_DEFAULT: 'Standard',
    MODE_EXTENDED: 'Erweitert',
    SOURCE: 'Quelle',
    TARGET: 'Ziel',
    TYPE_STRING: 'String',
    TYPE_NUMERIC: 'Numeric',
    TYPE_DATE: 'Date',
    REGULAR_EXPRESSION: 'Regulärer Ausdruck',
    REGEX_MODIFIERS: 'Modifikatoren',
    RESET: 'Zurücksetzen',
    ERROR: 'Fehler',
    HINT: 'Hinweis',
    MAIL: 'Mail',
    SEND_INTERNAL_PDF: 'Internes PDF senden',
    SEND_FILLED_PDF: 'Ausgefülltes PDF senden',
    USER: 'Benutzer',
    FILLER: 'Ausfüller',
    NET_DIAGRAM: 'Netzdiagramm',
    OMIT_PATIENT_DATA: 'Patientendaten auslassen',
    NUMBER_RANGE: 'Zahlenbereich',
    ENTRIES: 'Einträge',
    DISTRIBUTION: 'Verteilung',
    DATASET_TITLE: 'Datensatz Titel',

    BAR_CHART: 'Balkendiagramm',
    COLUMN_CHART: 'Säulendiagramm',
    LINE_CHART: 'Liniendiagramm',
    PIE_CHART: 'Kreisdiagramm',
    CHART_TITLE: 'Diagramm-Titel',
    CHART_WIDTH: 'Breite (%)',
    CHART_ALIGNMENT: 'Ausrichtung',
    CHART_ALIGNMENT_LEFT: 'Links',
    CHART_ALIGNMENT_CENTER: 'Zentral',
    CHART_ALIGNMENT_RIGHT: 'Rechts',
    X_AXIS_LABEL: 'Beschriftung X-Achse',
    Y_AXIS_LABEL: 'Beschriftung Y-Achse',
    ENTRY_LABEL: 'Benennung',
    ENTRY_COLOR: 'Farbe',
    ADD_LINE: 'Linie hinzufügen',
    LINE_TITLE: 'Linientitel',
    SORT_BY_VALUE: 'Nach Größe sortieren (Uhrzeigersinn)',

    IMAGE_DISPLAY_OPTIONS: 'Darstellung in Dokumentansicht und PDF',
    IMAGE_WIDTH_PERCENT: 'Breite in % der Seitenbreite',
    IMAGE_FULL_WIDTH: 'Auf Seitenbreite (max. Originalgröße)',

    SUCCESSFULLY_TRANSLATED: 'Die Übersetzung wurde erfolgreich abgeschlossen.',
    AUTOMATIC_QUESTIONNAIRE_TRANSLATION: 'Automatische Fragebogen Übersetzung',
    TRANSLATE_QUESTIONNAIRE: 'Fragebogen übersetzen',
    ERROR_AUTO_TRANSLATING: 'Beim automatischen Übersetzen ist ein Fehler aufgetreten',
    CHARS: 'Zeichen',

    RADIO_BUTTONS: 'Radio Buttons',
    DROPDOWN: 'Dropdown',

    DOCUMENT_SCAN: 'Dokument scannen',
    DOCUMENT_SCAN_MIN_PAGES: 'Mindestanzahl Seiten',
    DOCUMENT_SCAN_MAX_PAGES: 'Höchstanzahl Seiten',

    REPEATABLE: 'Wiederholbar',
    EMAIL: 'E-Mail',
    EMAIL_SENDING_TO: 'E-Mail-Versand an:',
    EMAIL_RECIPIENTS_FIXED: 'Feste E-Mail Adresse(n), mehrere kommagetrennt',
    EMAIL_SEND_TO_ASSIGNER: 'An zuweisenden Benutzer senden',
    EMAIL_SEND_TO_FILLER: 'An Ausfüller senden',
    EMAIL_WHAT_TO_SEND: 'Was soll gesendet werden?',
    EMAIL_ATTACH_FILLED_PDF: 'Ausgefülltes Fragebogen-PDF anhängen',
    EMAIL_ATTACH_REPORT_PDF: 'Bericht-PDF anhängen',
    EMAIL_ATTACH_FILLED_DOCX: 'Word-Dokument anhängen',
    EMAIL_ATTACH_REPORT_DOCX: 'Bericht Word-Dokument anhängen',
    EMAIL_INCLUDE_ASSET_LINKS: 'Links zu Dateien hinzufügen',
    EMAIL_RECIPIENTS_INVALID: 'Bitte gültige E-Mail-Adresse(n) angeben (kommagetrennt).',

    PAGE_VIEW: 'Seitenansicht',
    PAGE: 'Seite',
    PREVIOUS_PAGE: 'Vorherige Seite',
    NEXT_PAGE: 'Nächste Seite',
    ADD_PAGE: 'Neue Seite einfügen',
    PAGE_ADDED_SUCCESSFULLY: 'Die Seite wurde erfolgreich eingefügt.',
    COPY_PAGE: 'Seite kopieren',
    PAGE_COPIED_SUCCESSFULLY: 'Die Seite wurde erfolgreich kopiert.',
    DELETE_PAGE: 'Seite löschen',
    CONFIRM_DELETE_PAGE: 'Möchten Sie diese Seite wirklich löschen?',
    PAGE_DELETED_SUCCESSFULLY: 'Die Seite wurde erfolgreich gelöscht.',
    MOVE_TO_PAGE: 'Auf Seite verschieben',
    TARGET_PAGE: 'Zielseite',
    INSERT_POSITION: 'Einfügeposition',
    PAGE_START: 'Anfang der Seite',
    PAGE_END: 'Ende der Seite',
    JUMP_TO_PAGE: 'Zur Zielseite springen',
    CONFIRM_MOVE_ELEMENT: 'Element wirklich auf diese Seite verschieben?',
    ELEMENT_MOVED_SUCCESSFULLY: 'Das Element wurde erfolgreich verschoben.',
    WIDTH_PERCENT: 'Breite %',
    WIDTH_PERCENT_SUM_WARNING: 'Die Summe der Spaltenbreiten überschreitet 100%.',
    JUMP: 'Springen',
    IMPORT_EXPORT: 'Import/Export',
    TRANSLATE: 'Übersetzen',
    QUESTIONNAIRE_SETTINGS: 'Einstellungen',
    NO_FILTER_GROUPS: 'Keine',
    SEARCH_FILTER_GROUPS: 'Fachgruppe suchen',
    NO_MATCHING_FILTER_GROUPS: 'Keine passende Fachgruppe gefunden',
    SETTINGS_GENERAL: 'Allgemein',
    SETTINGS_EVALUATION: 'Auswertung',
    SETTINGS_OUTPUT: 'Ausgabe',
    MOVE_LEFT: 'Nach links',
    MOVE_RIGHT: 'Nach rechts',
    CONDITIONS_TAB: 'Bedingungen',
    SEARCH_ELEMENT: 'Element suchen',
    NO_MATCHING_ELEMENTS: 'Keine passenden Elemente gefunden',
    CURRENT_PAGE: 'aktuell',
    TRANSLATION_SERVICE: 'Übersetzungsdienst',
    SOURCE_LANGUAGE: 'Ausgangssprache',
    TARGET_LANGUAGES: 'Zielsprachen',
    ESTIMATED_COST: 'geschätzte Kosten',
    SELECT_ALL: 'Alle auswählen',
    DESELECT_ALL: 'Auswahl aufheben',
    SEARCH_VARIABLE: 'Variable suchen',
    SEARCH_FORMULA: 'Name oder Formel suchen',
    EXPAND_ALL_FORMULAS: 'Alle aufklappen',
    COLLAPSE_ALL_FORMULAS: 'Alle zuklappen',
    FORMULA_EMPTY: 'Noch keine Formel',
    FORMULA_UNSAVED: 'Ungespeichert',
    NO_MATCHING_VARIABLES: 'Keine passenden Variablen gefunden',
    OMIT_PATIENT_DATA_IN_TABLE_EXPORT: 'Patientendaten im Tabellen Export auslassen',

    AI_ASSISTANT: 'KI-Assistent',
    AI_INTRO: 'Beschreiben Sie, welchen Fragebogen die KI erstellen soll. Sie erhalten zuerst einen Vorschlag, den Sie bestätigen oder anpassen können.',
    AI_PLACEHOLDER: 'Nachricht an den KI-Assistenten eingeben...',
    AI_SEND: 'Senden',
    AI_CONFIRM_PLAN: 'Plan bestätigen & erstellen',
    AI_CONFIRM_MESSAGE: 'Ja, bitte erstellen.',
    AI_PROPOSED_PLAN: 'Vorschlag',
    AI_WORKING: 'KI arbeitet...',
    AI_RESULT_READY: 'Der Fragebogen wurde generiert und kann in den Editor übernommen werden.',
    AI_APPLY: 'In Editor übernehmen',
    AI_APPLIED: 'Der generierte Fragebogen wurde in den Editor übernommen. Bitte prüfen und speichern.',
    AI_NEW_SESSION: 'Neue Unterhaltung',
    AI_SESSION_ERROR: 'Bei der KI-Anfrage ist ein Fehler aufgetreten',
    AI_TOOL_PROPOSE_PLAN: 'Erstelle Vorschlag',
    AI_TOOL_READ_SCHEMA_DOCS: 'Prüfe Fragebogen-Spezifikation',
    AI_TOOL_BASH: 'Führe Berechnung aus',
    AI_TOOL_WRITE: 'Generiere Fragebogen',
    AI_TOOL_EDIT: 'Überarbeite Fragebogen',
    AI_TOOL_ANALYZE: 'Analysiere Daten',
    AI_TOOL_VALIDATE: 'Validiere Fragebogen',
    AI_TOOL_SUBMIT: 'Stelle Fragebogen fertig',
    AI_TOOL_READ_DOCUMENT: 'Lese Dokument',
    AI_ATTACH: 'Datei anhängen (PDF oder Bild)',
    AI_ATTACHMENT_PROMPT: 'Bitte erstelle einen Fragebogen aus der angehängten Datei.',
    AI_FILE_UNSUPPORTED: 'Dieser Dateityp wird nicht unterstützt. Erlaubt sind PDF, PNG, JPG und WebP',
    AI_FILE_TOO_LARGE: 'Die Datei ist zu groß. Maximal 10 MB pro Datei',
    AI_TOO_MANY_FILES: 'Es können maximal 5 Dateien pro Nachricht angehängt werden.'
  }
};
